export default "__VITE_ASSET__BhZs5Ip0__"